/// <reference path="../../app.typings.d.ts" />
'use strict';
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var app;
(function (app) {
    var Modals;
    (function (Modals) {
        var EditReportConfigModalController = /** @class */ (function (_super) {
            __extends(EditReportConfigModalController, _super);
            function EditReportConfigModalController($scope, $uibModalInstance, modalOptions, applicationService, applicationApiService, authenticationService, locationService) {
                var _this = _super.call(this, $uibModalInstance) || this;
                _this.$scope = $scope;
                _this.$uibModalInstance = $uibModalInstance;
                _this.modalOptions = modalOptions;
                _this.applicationService = applicationService;
                _this.applicationApiService = applicationApiService;
                _this.authenticationService = authenticationService;
                _this.locationService = locationService;
                /* Date Range */
                var date = new Date();
                var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
                var sevenDaysAgo = new Date(date.getTime() - (7 * 24 * 60 * 60 * 1000));
                var thirtyDaysAgo = new Date(date.getTime() - (30 * 24 * 60 * 60 * 1000));
                $scope.datePicker = {
                    date: {
                        startDate: firstDayOfMonth,
                        endDate: date
                    }
                };
                $scope.options = {
                    locale: {
                        format: 'MM/DD/YYYY'
                    },
                    ranges: {
                        'Month to Date': [firstDayOfMonth, date],
                        'Last 7 Days': [sevenDaysAgo, date],
                        'Last 30 Days': [thirtyDaysAgo, date]
                    }
                };
                /* Write Up Types */
                $scope.writeUpTypes = ap.Constants.writeUpTypes;
                $scope.selectedWriteUpType = $scope.writeUpTypes[0];
                /* Service Advisors */
                $scope.serviceAdvisors = [''];
                $scope.selectedServiceAdvisors = [''];
                $scope.orgUnitCacheKey = _this.locationService.getOrganizationCacheKey(undefined, true, true);
                _this.applicationApiService.getServiceAdvisors($scope.orgUnitCacheKey).then(function (result) {
                    $scope.serviceAdvisors = result;
                    $scope.selectedServiceAdvisors =
                        (!ap.Utilities.isNullOrUndefined(_this.applicationService.reportParameters) &&
                            !ap.Utilities.isNullOrUndefined(_this.applicationService.reportParameters.advisors)) ? _this.applicationService.reportParameters.advisors : angular.copy($scope.serviceAdvisors);
                });
                $scope.$watch('selectedServiceAdvisors', function (newVal, oldVal) {
                    if (!$scope.serviceAdvisors) {
                        $('#reportServiceAdvisors').find('button').text('All Service Advisors');
                    }
                    else if ($scope.selectedServiceAdvisors) {
                        if ($scope.selectedServiceAdvisors.length < 1) {
                            $('#reportServiceAdvisors').find('button').text('Select a Service Advisor');
                        }
                        else if ($scope.selectedServiceAdvisors.length === $scope.serviceAdvisors.length) {
                            $('#reportServiceAdvisors').find('button').text('All Service Advisors');
                        }
                        else {
                            $('#reportServiceAdvisors').find('button').text($scope.selectedServiceAdvisors.join(', '));
                        }
                    }
                });
                // load previous values into modal if they exist
                if (_this.applicationService.reportParameters) {
                    $scope.datePicker = {
                        date: {
                            startDate: _this.applicationService.reportParameters.rptBeginDate,
                            endDate: _this.applicationService.reportParameters.rptEndDate
                        }
                    };
                    if (!ap.Utilities.isNullOrUndefined(_this.applicationService.reportParameters.arrivalType)) {
                        $scope.selectedWriteUpType = $scope.writeUpTypes[_this.applicationService.reportParameters.arrivalType];
                    }
                }
                return _this;
            }
            EditReportConfigModalController.prototype.initResult = function (action) {
                this.result = this.result || { action: action };
                this.result.action = action;
                return this.result;
            };
            EditReportConfigModalController.prototype.viewReport = function () {
                var _this = this;
                var reportParams = {
                    orgUnitCacheKey: this.$scope.orgUnitCacheKey,
                    beginDateTimeString: this.$scope.datePicker.date.startDate,
                    endDateTimeString: this.$scope.datePicker.date.endDate,
                    rptBeginDate: this.$scope.datePicker.date.startDate,
                    rptEndDate: this.$scope.datePicker.date.endDate,
                    advisors: (!this.$scope.selectedServiceAdvisors || this.$scope.selectedServiceAdvisors.length === this.$scope.serviceAdvisors.length) ? null : this.$scope.selectedServiceAdvisors,
                    arrivalType: this.$scope.selectedWriteUpType.id
                };
                this.applicationService.getActiveReport()
                    .then(function (activeReport) {
                    _this.applicationService.reportParameters = reportParams;
                    _this.$uibModalInstance.close(_this.initResult(ModalActionResult.Saved));
                    if (_this.locationService.isOnPage(ap.Constants.routes.reportDisplay)) {
                        _this.locationService.redirect(ap.Constants.routes.reportDisplay, activeReport.ssrsName, _this.$scope.orgUnitCacheKey);
                    }
                });
            };
            EditReportConfigModalController.$inject = [
                '$scope',
                '$uibModalInstance',
                'modalOptions',
                'applicationService',
                'applicationApiService',
                'authenticationService',
                'locationService'
            ];
            return EditReportConfigModalController;
        }(Modals.BaseModalController));
        Modals.EditReportConfigModalController = EditReportConfigModalController;
        angular.module('app.Modals')
            .controller('EditReportConfigModalController', EditReportConfigModalController);
    })(Modals = app.Modals || (app.Modals = {}));
})(app || (app = {}));
